
const words = {
  Status: 'Status',
  Company: 'Empresa',
  Companies: 'Empresas',
  Value: 'Valor',
  Date: 'Data',
  Transaction: 'Transação',
  Transactions: 'Transações',
  Today: 'Hoje',
  Prev: 'Anterior',
  Next: 'Próximo',
  Waiting: 'Aguardando',
  Processing: 'Processando',
  Canceled: 'Cancelado',
  CanceledPlural: 'Cancelados',
  Expired: 'Expirado',
  ExpiredPlural: 'Expirados',
  Approved: 'Aprovado',
  ApprovedPlural: 'Aprovados',
  Inconclusive: 'Inconclusivo',
  Inconclusives: 'Inconclusivos',
  Refused: 'Recusado',
  RefusedPlural: 'Recusados',
  Shared: 'Compartilhado',
  SharedPlural: 'Compartilhados',
  Apply: 'Aplicar',
  Cancel: 'Cancelar',
  Report: 'Relatório',
  Reports: 'Relatórios',
  Panel: 'Painel',
  Settings: 'Configurações',
  Logout: 'Logout',
  final: 'final',
  Hello: 'Olá',
  Information: 'Informação',
  Back: 'Voltar',
  Confirm: 'Confirmar',
  Continue: 'Continuar',
  seconds: 'segundos',
  Select: 'Selecione',
  Chargebaks: 'Contestações',
  CopyLink: "Copiar link",
}

const errors = {
  "MSG_ERROR_40024": "O nome informado não é válido",
  "MSG_ERROR_40021": "O telefone informado não é válido",
  "MSG_ERROR_40022": "O email informado não é válido",
  "MSG_ERROR_40027": "Já foi enviada uma transação com esse número do pedido",
  "MSG_ERROR_40045": "O valor da transação ultrapassa os limites aceitos",
  "MSG_ERROR_40012": "Não conseguimos autenticar a foto. Tente novamente.",
  "MSG_ERROR_DEFAULT": "Ops! Algo Inesperado aconteceu. Tente novamente dentro de alguns segundos.",
  "MSG_ERROR_CREATE_TRANSACTION": "Não foi possível criar a transação.",
}

const msg_report = {
  "MSG_ERROR_REPORT_204": "Não existem transações com os filtros selecionados.",
  "MSG_ERROR_REPORT_40035": "A quantidade de transações excede o limite máximo. Por favor, selecione um período menor.",
  "MSG_ERROR_REPORT_40047": "O intervalo de datas selecionado não é permitido.",
  "MSG_ERROR_REPORT_DEFAULT": "Não foi possível gerar o relatório agora. Tente novamente mais tarde.",
  "MSG_SUCCESS_REPORT": "Recebemos o pedido de geração de documento: o relatório será enviado para o seu e-mail.",
};

const buttons = {
  owner: 'Sou o titular',
}

export default {
  translations: {
    ...words,
    ...errors,
    ...msg_report,
    ...buttons,
    'BodyEvidence': 'Conjunto Probatório',
    'chooseCompany': 'Escolha a empresa',
    'footer.privacyPolicy': 'Política de privacidade',
    'footer.allRightsReserved': 'Todos os direitos reservados',
    'footer.lastUpdate': 'Última atualização em',
    'filter.selectPeriod': 'Selecionar período',
    'button.newAutentication': 'Nova autenticação',
    'search.placeholder': 'N° do pedido ou CPF',
    'msg.warning.maxFilterByDate': 'Não é possível filtrar um período maior que {{max}} dias',
    'msg.warning.invalidDateRange': 'O intervalo de datas selecionado não é permitido.',
    'transactions.title': words.Transactions,
    'transactions.dateDays': '{{days}} dias',
    'transactions.columns.orderNumber': 'N° pedido',
    'transactions.columns.company': words.Company,
    'transactions.columns.companyKind': 'Tipo de uso',
    'transactions.columns.identificationDoc': 'CPF',
    'transactions.columns.value': words.Value,
    'transactions.columns.cardNumber': 'Cartão de Crédito',
    'transactions.columns.date': words.Date,
    'transactions.columns.status': words.Status,
    'transaction.status.processHeader.filterLabel': 'Status do <strong>processo</strong>',
    'transaction.status.responseHeader.filterLabel': 'Status de <strong>resposta</strong>',
    'transaction.status.userActionsHeader.filterLabel': 'Status de <strong>ações do usuário</strong>',
    'transaction.status.approved.label': words.Approved,
    'transaction.status.approved.filterLabel': words.ApprovedPlural,
    'transaction.status.canceled.label': words.Canceled,
    'transaction.status.canceled.filterLabel': words.CanceledPlural,
    'transaction.status.absentHolder.label': 'Titular ausente',
    'transaction.status.absentHolder.filterLabel': 'Titular ausente',
    'transaction.status.disapproved.label': words.Refused,
    'transaction.status.disapproved.filterLabel': words.RefusedPlural,
    'transaction.status.inconclusive.label': words.Inconclusive,
    'transaction.status.inconclusive.filterLabel': words.Inconclusives,
    'transaction.status.fastInconclusive.label': 'Inconclusivo rápido',
    'transaction.status.fastInconclusive.filterLabel': 'Inconclusivos rápido',
    'transaction.status.processing': words.Processing,
    'transaction.status.shared.label': words.Shared,
    'transaction.status.shared.filterLabel': words.SharedPlural,
    'transaction.status.waiting': words.Waiting,
    'transaction.status.skiped': 'Pulou biometria',
    'transaction.status.unknownShare.label': 'Não reconhece',
    'transaction.status.unknownShare.filterLabel': 'Não reconhece compra',
    'transaction.status.expired.label': words.Expired,
    'transaction.status.expired.filterLabel': words.ExpiredPlural,
    'transaction.chargeback.none': 'Sem pedido',
    'transaction.chargeback.waiting.label': 'Aguardando análise',
    'transaction.chargeback.waiting.detailLabel': 'Aguardando análise...',
    'transaction.chargeback.refused.label': 'Chargeback negado',
    'transaction.chargeback.refused.detailLabel': 'Negado',
    'transaction.chargeback.accepted.label': 'Aceito',
    'transaction.chargeback.analyzing.label': 'Aguardando análise',
    'transaction.chargeback.approved.label': 'Chargeback aprovado',
    'transaction.chargeback.approved.detailLabel': words.Approved,

    /* Chargeback */
    'chargeback.newUpload.button': 'Nova Contestação',
    'chargeback.newUpload.title': 'Faça o upload da lista de contestações',
    'chargeback.newUpload.subtitle': 'Faça o upload do arquivo CSV, contendo os dados dos pedidos que necessitam de análise de contestação.',
    'chargeback.newUpload.label': 'Anexe o arquivo CSV',
    'chargeback.newUpload.failLabel': 'Não foi possível enviar o arquivo',
    'chargeback.newUpload.successLabel': 'Upload realizado com sucesso',
    'chargeback.newUpload.cancel.button': 'Cancelar',
    'chargeback.newUpload.close.button': 'Fechar',
    'chargeback.newUpload.send.button': 'Enviar',
    'chargeback.list.noPermission': 'Usuário sem permissão de ver as transações de {{profileName}}',
    'chargeback.details.viewTransaction.button': 'Visualizar transação',
    'chargeback.details.infoTitle': 'Informações sobre o pagamento',
    'chargeback.details.cpf': 'CPF:',
    'chargeback.details.card': 'Cartão:',
    'chargeback.details.value': 'Valor:',
    'chargeback.details.phone': 'Celular:',
    'chargeback.details.email': 'E-mail:',
    'chargeback.details.generateProbative.button': 'Gerar conjunto probatório',
    'chargeback.details.denied.button': 'Negou',
    'chargeback.details.accepted.button': 'Acatou',
    'chargeback.uploadAlert.processing.title': 'Processando arquivos de contestações',
    'chargeback.uploadAlert.processing.description': 'Os seguintes arquivos ainda estão sendo processados:',
    'chargeback.uploadAlert.success.title': 'Todos os arquivos de contestações foram processados com sucesso!',

    /* Report */
    'report.title': words.Reports,
    'report.filters.title': 'Selecione os filtros e períodos desejados para exportar o relatório',
    'report.filters.companies': words.Companies,
    'report.filters.status': words.Status,
    'report.filters.chargeback': 'Chargeback',
    'report.filters.obs': 'Obs.: O relatório será enviado para o seu email',
    'report.filters.button.generate': 'Gerar o documento ',

    /* Dashboard */
    'dashboard.warning': 'Algumas transações ainda estão em processamento, por isso os números sofrerão alterações ao longo do dia',
    'dashboard.transactions.approved': 'Transações aprovadas',
    'dashboard.transactions.eligible': 'Transações elegíveis',
    'dashboard.transactions.received': 'Transações recebidas',
    'dashboard.transactions.viewAll': 'Ver todas transações',
    'dashboard.value.approved': 'Valor aprovado',
    'dashboard.value.received': 'Valor recebido',
    'dashboard.percentage.opened': 'Taxa de abertura',
    'dashboard.percentage.captured': 'Taxa de captura',
    'dashboard.approval.resume': 'Aprovação total',

    /* Settings */
    'settings.add': 'Adicionar',
    'settings.allowedDomains': 'Domínios liberados',
    'settings.maxAllowedDomainsExceeded': 'Número máximo de domínios',
    'settings.domainText': 'Texto do domínio',
    'settings.deleteDomain': 'Excluir domínio',

    /* Issuer Portal */
    'issuer.transactions.columns.company': 'Estabelecimento',
    'issuer.transactions.columns.date': 'Data da transação',
    'issuer.transactions.columns.consult': 'Consulta',

    'issuer.chargebacks.columns.dateTime': 'Data e hora',
    'issuer.chargebacks.columns.company': 'Empresa',
    'issuer.chargebacks.columns.transactionId': 'ID da transação no IDPay',
    'issuer.chargebacks.columns.creditCard': 'Cartão de crédito',
    'issuer.chargebacks.columns.cpf': 'CPF',
    'issuer.chargebacks.columns.value': 'Valor',
    'issuer.chargebacks.columns.status': 'Status',


    /* Card Consult */
    'card-consult.approved': 'Válido',
    'card-consult.unsure': 'Inválido',
    'card-consult.waiting': 'Aguardando',

    /* Modal Notify Chargeback */
    'transaction.modal.notifyChargeback.filesRequired': 'A comprovação do chargeback é obrigatória',
    'transaction.modal.notifyChargeback.fail': 'Não foi possível enviar a contestação',
    'transaction.modal.notifyChargeback.success': 'Contestação enviada',
    'transaction.modal.notifyChargeback.cancel': words.Cancel,
    'transaction.modal.notifyChargeback.confirm': words.Confirm,
    'transaction.modal.notifyChargeback.title': 'Nova contestação',

    'transaction.modal.notifyChargeback.form.chargebackDate': 'Data da contestação*',
    'transaction.modal.notifyChargeback.form.document': 'CPF da pessoa que contestou*',
    'transaction.modal.notifyChargeback.form.name': 'Nome da pessoa que contestou*',
    'transaction.modal.notifyChargeback.form.reason': 'Motivo da contestação*',
    'transaction.modal.notifyChargeback.form.obs': 'Observações',
    'transaction.modal.notifyChargeback.form.attachEvidences': 'Anexar evidências*',
    'transaction.modal.notifyChargeback.form.attachEvidencesObs': 'Obs.: a comprovação do chargeback é obrigatória',
    'transaction.modal.notifyChargeback.form.file': 'Anexar evidências*',

    'transaction.modal.notifyChargeback.upload.attachEvidencesObs': 'Obs.: a comprovação do chargeback é obrigatória',
    'transaction.modal.notifyChargeback.upload.label': 'Anexe aqui o documento',
    'transaction.modal.notifyChargeback.upload.failLabel': 'Não foi possível enviar o arquivo de contestação',
    'transaction.modal.notifyChargeback.upload.successLabel': 'Arquivo de contestação enviados com sucesso',
    'transaction.modal.notifyChargeback.upload.ruleMaxFilesMessage': 'A quantidade máxima de evidências foi atingida',

    /* Manual Workflow Screens */
    'sms.footer.altImgSafe': 'Ambiente seguro',
    'sms.orderSummary.company': 'Local da compra',
    'sms.orderSummary.value': 'Valor total da compra',
    'sms.orderSummary.creditCard': 'Cartão de crédito',
    'sms.orderSummary.captureDate': 'Quando a selfie foi tirada',
    'sms.orderSummary.title': 'Dados da compra',
    'sms.tips.title': 'Dicas de captura',
    'sms.tips.cameraAccess': 'Permita o acesso à câmera',
    'sms.tips.areaLit': 'Encontre uma área bem iluminada',
    'sms.tips.phoneEye': 'Segure o telefone no nível dos olhos',
    'sms.tips.removeGlasses': 'Retire óculos, máscara, chapéu e fones',
    'sms.photoAlreadyTaken': 'Já tirei a foto',
    'sms.buttonShare': 'Enviar para o titular',
    'sms.modalSDKError.title': 'Ops! Algo deu errado.',
    'sms.modalCopyLink.mobileTitle': 'Mobile - Autenticação',
    'sms.modalCopyLink.wallet.mobileTitle': 'Validação de Identidade',
    'sms.modalCopyLink.title': 'Link copiado',
    'sms.modalCopyLink.text': 'O link foi copiado e pode ser compartilhado através do WhatsApp',
    'sms.notify.confirmOwnerData.label.creditCard': 'Cartão de crédito:',
    'sms.notify.confirmOwnerData.title': 'Confirme o CPF do titular do cartão',
    'sms.notify.confirmOwnerData.subtitle': 'Para sua segurança, informe o CPF correto do titular do cartão de crédito para validar sua identidade.',
    'sms.notify.confirmOwnerData.labelCPF': 'CPF do titular:',
    'sms.validateWaitMsg': 'Estamos analisando suas informações',
    'sms.waitMsg': 'Aguarde um momento',
    'sms.sharedSteps.alreadyShared.title': 'Você compartilhou o link com o titular do cartão',
    'sms.sharedSteps.alreadyShared.titleWithWarning': 'Se já compartilhou, é só esperar o titular finalizar. Se não, envie o link abaixo.',
    'sms.sharedSteps.alreadyShared.subtitle': 'A validação está pendente até a foto ser capturada.',
    'sms.sharedSteps.alreadyShared.labelOwner': 'O titular está próximo a você?',
    'sms.sharedSteps.alreadyShared.buttonContinueCapture': 'Continuar captura',
    'sms.sharedSteps.alreadyShared.warningMessage': 'Não feche essa página até finalizar a autorização',
    'sms.sharedSteps.congratulations.title': 'Validação finalizada',
    'sms.sharedSteps.congratulations.subtitle': 'Você terminou, aguarde o retorno da empresa.',
    'sms.sharedSteps.congratulations.wallet.title': 'Você terminou! Essa validação foi finalizada.',
    'sms.sharedSteps.congratulationsReturnToDevice.subtitle': 'Volte ao dispositivo inicial.',
    'sms.sharedSteps.error.title': 'Transação não existente',
    'sms.sharedSteps.error.subtitle': 'Para mais informações entre em contato com o estabelecimento da sua compra.',
    'sms.sharedSteps.reloadTransaction.title': 'Ops, tivemos um problema',
    'sms.sharedSteps.reloadTransaction.subtitle': 'Por favor, clique no botão abaixo para reiniciar a validação.',
    'sms.sharedSteps.reloadTransaction.button': 'Reiniciar validação',
    'sms.sharedSteps.expired.title': 'Esse link está expirado!',
    'sms.sharedSteps.expired.subtitle': 'Para mais informações entre em contato com o estabelecimento da sua compra.',
    'sms.sharedSteps.socialEngineering.title': 'Fique atento a golpes!',
    'sms.sharedSteps.socialEngineering.subtitle': 'Ao confirmar a compra, você estará realizando um pagamento com este cartão abaixo. Verifique se reconhece esta compra antes de continuar.',
    'sms.sharedSteps.socialEngineering.cardUsed': 'Cartão utilizado:',
    'sms.sharedSteps.socialEngineering.buttonConfirm': 'Confirmar a compra',
    'sms.sharedSteps.fakedoorYou.title': 'Não conseguimos validar a titularidade do seu cartão.',
    'sms.sharedSteps.fakedoorYou.subtitle': 'Gostaria de concluir sua compra a partir de um cartão pré-aprovado?',
    'sms.sharedSteps.fakedoorYou.buttonPreApprovedCard': 'Concluir com cartão pré-aprovado',
    'sms.sharedSteps.fakedoorYou.buttonCurrentCard': 'Concluir com cartão atual',
    'sms.sharedSteps.fakedoorYou.underConstruction.title': 'Funcionalidade em construção',
    'sms.sharedSteps.fakedoorYou.underConstruction.subtitle': 'A conclusão com cartão pré-aprovado ainda está sendo preparada. Em instantes você volta para a finalização da sua compra.',
    'sms.sharedSteps.fakedoorYou.underConstruction.buttonClose': 'Fechar',
    'sms.sharedSteps.incorrectLink.title': 'Não encontramos a validação',
    'sms.sharedSteps.incorrectLink.subtitle': 'Confira se o link foi digitado corretamente.',
    'sms.sharedSteps.incorrectLink.warning': 'Em casos de compartilhamento, confira se o link foi copiado por completo.',
    'sms.sharedSteps.orderNotRecognized.title': 'Compra não reconhecida',
    'sms.sharedSteps.orderNotRecognized.subtitle': 'Estamos informando o estabelecimento sobre a compra indevida',
    'sms.sharedSteps.prepare.subtitleWithInstruction': 'Vamos usar a foto para confirmar sua identidade. Por isso:',
    'sms.sharedSteps.prepare.msgWait': 'Estamos nos preparando para capturar sua selfie',
    'sms.sharedSteps.prepare.buttonCaptureSelfie': 'Continuar',
    'sms.sharedSteps.QRCode.title': 'Aponte a câmera do seu celular para o QRCode ou copie o link',
    'sms.sharedSteps.QRCode.subtitle': 'Após tirar a foto, <strong>volte para finalizar</strong> a validação nesta página',
    'sms.sharedSteps.QRCode.warning': 'Não feche esta página enquanto captura a foto',
    'sms.sharedSteps.QRCode.desktopError.title': 'Não conseguimos acessar sua câmera',
    'sms.sharedSteps.QRCode.desktopError.subtitle': 'Continue essa transação em outro dispositivo. Aponte a câmera do seu celular para o QR Code ou compartilhe o link clicando no botão abaixo.',
    'sms.sharedSteps.sharingVerification.title': 'Você <strong>compartilhou</strong> o link com o titular do cartão',
    'sms.sharedSteps.sharingVerification.titleWithWarning': 'Se já <strong>compartilhou</strong>, é só esperar o titular finalizar. Se não, envie o link abaixo.',
    'sms.sharedSteps.sharingVerification.subtitle': 'A validação está pendente até a foto ser tirada',
    'sms.sharedSteps.sharingVerification.owner': 'Seguir validação por aqui',
    'sms.sharedSteps.sharingVerification.warningMessage': 'Não feche essa página até finalizar a autorização',
    'sms.copyLink.title': 'Link copiado',
    "sms.share.auth.title": "Autorize o uso do seu cartão",
    "sms.share.auth.subtitle": "O seu cartão está sendo utilizado no pagamento abaixo.",
    "sms.share.auth.fieldName": "Nome escrito no cartão:",
    "sms.validateCPF": "Digite o CPF completo",
    "sms.cpfRetryDefaultMessage": "Atenção: Verifique se o CPF é o do titular do cartão",
    "sms.share.auth.buttonConfirm": "Autorizar o uso",
    'sms.button.photoWebcam': 'Tirar foto com webcam',
    'sms.button.photoMobile': 'Tirar foto com celular',
    'sms.button.unknown': 'Não reconheço essa compra',
    'sms.button.notOwner': 'Não sou o titular',
    'sms.button.notOwner.label': 'Você é o titular do cartão utilizado?',
    'sms.modal.orderNotRecognized.title': 'Tem certeza que não reconhece essa compra?',
    'sms.modal.orderNotRecognized.text': 'Ao seguir, iremos avisar o estabelecimento sua confirmação.',
    'sms.modal.orderNotRecognized.confirmButton': 'Não reconheço a compra',
    'sms.modal.notOwner.title': 'O titular está presente?',
    'sms.modal.notOwner.text': 'Se você estiver próximo à pessoa titular, por favor, passe o dispositivo para essa pessoa prosseguir com a validação.',
    'sms.modal.notOwner.confirmButton': 'Continuar validação',
    'sms.modal.notOwner.closeButton': 'Finalizar validação',
    'sms.modal.selfieNotFound.title': 'Selfie não encontrada',
    'sms.modal.selfieNotFound.text': 'Finalize a captura no dispositivo móvel para seguir com a validação.',
    'sms.modal.selfieNotFound.confirmButton': 'Ok, entendi',
    'chooseLanguage': 'Escolha o idioma',
    'chooseLanguage.PT': 'Português',
    'chooseLanguage.EN': 'English',
    'chooseLanguage.ES': 'Español',
    'chooseLanguage.KK': 'қазақ',
    'sms.popUpPermissions.title': 'Para seguir, vamos te pedir a permissão de acesso abaixo',
    'sms.popUpPermissions.camera.title': 'Câmera',
    'sms.popUpPermissions.camera.text': 'Usamos essa permissão para capturar a foto do seu rosto.',
    'sms.bannerAlertContestation.text': 'Ao continuar a validação, você confirma que realizou o pagamento com este cartão de crédito e não poderá contestar a compra por fraude.',

    'sms.sharedSteps.sharingVerification.helpPermission.buttonTryAgain': 'Tentar novamente',
    'sms.sharedSteps.sharingVerification.helpPermission.titleInstructions': 'Instruções para <strong>permissão de câmera</strong>',
    'sms.sharedSteps.sharingVerification.helpPermission.titleWithBrowser': 'Saiba como permitir acesso à câmera no <br/> <icon/> <strong>{{name}}</strong>',
    'sms.sharedSteps.sharingVerification.helpPermission.titleWithoutBrowser': 'Saiba como permitir acesso à câmera no <strong>{{name}}</strong>',
    'sms.sharedSteps.sharingVerification.helpPermission.android': 'Android',
    'sms.sharedSteps.sharingVerification.helpPermission.ios': 'iOS',
    'sms.sharedSteps.sharingVerification.helpPermission.windows': 'Windows',
    'sms.sharedSteps.sharingVerification.helpPermission.macOS': 'macOS',
    'sms.sharedSteps.sharingVerification.helpPermission.titleNoPermission': 'Entenda como pode realizar essa permissão',
    'sms.sharedSteps.sharingVerification.helpPermission.subtitleNoPermission': 'Selecione o modelo utilizado e siga as instruções',
    'sms.sharedSteps.sharingVerification.helpPermission.haveOS': 'Tenho {{name}}',
    'sms.sharedSteps.sharingVerification.helpPermission.instructionPermission': 'Instruções de permissão',
    'sms.sharedSteps.sharingVerification.helpPermission.googleChrome': 'Google Chrome',
    'sms.sharedSteps.sharingVerification.helpPermission.samsunginternet': 'Samsung Internet',
    'sms.sharedSteps.sharingVerification.helpPermission.safari': 'Safari',
    'sms.sharedSteps.sharingVerification.helpPermission.mozillaFirefox': 'Mozilla Firefox',
    'sms.sharedSteps.sharingVerification.helpPermission.otherBrowser': 'Outro navegador',
    'sms.sharedSteps.sharingVerification.helpPermission.browser': 'Navegador',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidChrome.1': 'À direita da barra de endereço, toque no três pontos <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidChrome.2': 'Toque em Configurações <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidChrome.3': 'Desça a tela e selecione a opção Configurações do site',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidChrome.4': 'Toque em Câmera e ative a permissão <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidChrome.5': 'Caso o link <strong>https://idpay.unico.io</strong> esteja bloqueado, selecione-o e aperte em Permitir',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidSamsungBrowser.1': 'À direita da barra inferior, selecione os três traços <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidSamsungBrowser.2': 'Selecione a opção Configurações <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidSamsungBrowser.3': 'Desça a página e selecione a opção Sites e downloads',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidSamsungBrowser.4': 'Toque em Permissões de site e ligue a Câmera <icon />',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidGenericBrowse.1': 'Abra o aplicativo Configurações <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidGenericBrowse.2': 'Desça a tela e selecione Aplicativos',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidGenericBrowse.3': 'Procure pelo nome do navegador que está utilizando',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidGenericBrowse.4': 'Toque em Permissões e selecione Câmera <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileAndroidGenericBrowse.5': 'Selecione a opção Permitir durante o uso do app e volte para salvar sua edição',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosChrome.1': 'Abra o aplicativo Ajustes',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosChrome.2': 'Desça a tela e toque em Chrome',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosChrome.3': 'Deixe a linha Câmera ativa <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosChrome.4': 'Recomece a captura e aceite o novo pedido de permissão',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosSafari.1': 'Abra o aplicativo Ajustes',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosSafari.2': 'Desça a tela e toque em Safari',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosSafari.3': 'Ao final da página, selecione Câmera e toque em permitir',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosGenericBrowser.1': 'Abra o aplicativo Ajustes',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosGenericBrowser.2': 'Desça a tela e toque no nome do navegador que está utilizando',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosGenericBrowser.3': 'Selecione a opção Câmera e toque em permitir <icon1 /> ou ativar <icon2 />',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.mobileIosGenericBrowser.4': 'Recomece a captura e aceite o novo pedido de permissão',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsChrome.1': 'Clique no erro de permissão ou no <strong>ícone de cadeado</strong> <icon/> à esquerda da barra de endereço.',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsChrome.2': 'Clique em <strong>Configurações do site</strong> <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsChrome.3': 'Clique em <strong>Privacidade e Segurança</strong> <icon/> e depois em <strong>Câmera</strong>, selecione <strong>”Permitir”</strong>.',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsMozilla.1': 'Clique no ícone de menu no canto superior direito da janela e selecione "Opções".',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsMozilla.2': 'Na barra lateral esquerda, clique em "Privacidade e Segurança".',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsMozilla.3': 'Desça até a seção "Permissões" e encontre a opção "Câmera".',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsMozilla.4': 'Deixe a opção ”Pedir para Ativar a Câmera” marcada.',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsMozilla.5': 'Caso o link desta página esteja bloqueado, clique em ”Exceções” e adicione para continua',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsGenericBrowser.1': 'Clique no erro de permissão ou no <strong>ícone de cadeado</strong> <icon/> à esquerda da barra de endereço.',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsGenericBrowser.2': 'Clique em <strong>Configurações do site</strong> <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopWindowsGenericBrowser.3': 'Clique em <strong>Privacidade e Segurança</strong> <icon/> e depois em <strong>Câmera</strong>, selecione <strong>”Permitir”</strong>.',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopMac.1': 'Clique no erro de permissão ou no <strong>ícone de cadeado</strong> <icon/> à esquerda da barra de endereço.',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopMac.2': 'Ative a <strong>Câmera</strong> com o seletor <icon/> ou clique em <strong>“continuar permitindo acesso à sua câmera”</strong>.',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopMac.3': 'Se a câmera está desligada nas configurações do Mac, clique em <strong>Abrir Preferências</strong>, ou acesse as <strong>Ajustes</strong> <icon/> do seu computador.',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopMac.4': 'Acesse <icon/> <strong>Câmera</strong>.',
    'sms.sharedSteps.sharingVerification.helpPermission.tips.desktopMac.5': 'Localize o navegador que você utiliza e habilite o seletor <icon/>',
    'sms.sharedSteps.sharingVerification.helpPermission.pageTitle': 'Você não permitiu o acesso à câmera',
    'sms.sharedSteps.sharingVerification.helpPermission.pageSubtitle': 'Sem o acesso, não podemos confirmar sua identidade e validar a compra.',
    'sms.sharedSteps.sharingVerification.helpPermission.buttonNotWorked': 'Ainda não funcionou?',
    'sms.sharedSteps.sharingVerification.helpPhotoQuality.titleTipPhoto': 'Mantenha seu rosto no centro da forma oval e siga as instruções abaixo:',
    'sms.sharedSteps.sharingVerification.helpPhotoQuality.pageTitle': 'Não conseguimos validar sua identidade',
    'sms.sharedSteps.sharingVerification.helpPhotoQuality.pageSubtitle': 'A qualidade da foto pode ter interferido na validação. Por favor, tente novamente.',
    'sms.sharedSteps.sharingVerification.helpPhotoQuality.tip1': 'Dicas para aumentar a qualidade da captura',
    'sms.sharedSteps.sharingVerification.helpPhotoQuality.tip2': 'Segure seu telefone na altura dos olhos.',
    'sms.sharedSteps.sharingVerification.helpPhotoQuality.tip3': 'Encontre um lugar bem iluminado e retire acessórios como chapéu, óculos, etc.',

    // New Sharing Verification
    'sms.sharedSteps.newSharingVerification.title': 'Se já compartilhou, é só esperar o titular finalizar. Se não, envie o link abaixo.',
    'sms.sharedSteps.newSharingVerification.shareLink': 'Compartilhe o link com o titular',
    'sms.sharedSteps.newSharingVerification.or': 'ou',
    'sms.sharedSteps.newSharingVerification.continueHere': 'Continue a autorização por aqui',
    'sms.sharedSteps.newSharingVerification.takeSelfie': 'Tirar selfie',
    'sms.sharedSteps.newSharingVerification.finishAuthorization': 'Finalizar autorização',

    // Frictionless flow
    'sms.notify.presentationFrictionless.title': 'Validação do cartão de crédito',
    'sms.notify.presentationFrictionless.subTitle': 'Para garantir a segurança do pagamento, precisamos validar a identidade do titular do cartão.',
    'sms.notify.presentationFrictionless.buttonContinueVerification': 'Começar a validação',
    'sms.sharedSteps.prepare.frictionless.title': 'Para finalizar, tire uma foto do titular do cartão utilizado na compra',
    'sms.sharedSteps.prepare.frictionless.title2': 'Tire a selfie do titular do cartão',
    'sms.sharedSteps.prepare.frictionless.continueButton': 'Tirar selfie',

    //Belvo
    'sms.notify.cardValidationBelvo.title': 'Validação do cartão de crédito',
    'sms.notify.cardValidationBelvo.subtitle': 'Precisamos conectar com o seu banco para validar a identidade do titular do cartão de crédito',
    'sms.notify.cardValidationBelvo.summary.header.alt': 'Open Finance Unico x Emissor',
    'sms.notify.cardValidationBelvo.summary.header.title': 'Validação via Open Finance',
    'sms.notify.cardValidationBelvo.summary.item1.title': 'Sobre o Open Finance',
    'sms.notify.cardValidationBelvo.summary.item1.desc': 'Open Finance é um método seguro de compartilhamento de dados financeiros entre diferentes instituições, regulado pelo Banco Central.',
    'sms.notify.cardValidationBelvo.summary.item2.title': 'Propósito da validação',
    'sms.notify.cardValidationBelvo.summary.item2.desc': 'A conexão com seu banco é apenas para validarmos sua identidade do titular do cartão de crédito.',
    'sms.notify.cardValidationBelvo.summary.item3.title': 'Dados utilizados',
    'sms.notify.cardValidationBelvo.summary.item3.desc1': '4 últimos dígitos do cartão de crédito',
    'sms.notify.cardValidationBelvo.summary.item3.desc2': 'Não coletamos outros dados',
    'sms.notify.cardValidationBelvo.summary.item4.title': 'Compartilhamento',
    'sms.notify.cardValidationBelvo.summary.item4.desc': 'Não compartilharemos os seus dados com a empresa {{company}}.',
    'sms.notify.cardValidationBelvo.button.verifyCard': 'Validar cartão',
    'sms.notify.cardValidationBelvo.button.notNow': 'Não quero validar',
    'sms.notify.cardValidationBelvo.pollingText': 'Continue a validação na nova aba.<br />Após finalizar, seguiremos por aqui.',

    'sms.notify.finishBelvo.finishText': 'Open Finance finalizado.<br />Por favor, volte para a aba anterior.<br />Iremos continuar por lá.',
    'sms.modal.notNow.title': 'Você tem certeza que deseja fechar essa validação?',
    'sms.modal.notNow.button.skipStep': 'Fechar validação',
    'sms.modal.notNow.button.backToValidation': 'Continuar',

    'sms.modal.errorBelvo.title': 'Tivemos um problema para conectar ao banco',
    'sms.modal.errorBelvo.text': 'Tente novamente para continuar com a validação do cartão.',
    'sms.modal.errorBelvo.button.tryAgain': 'Tentar novamente',

    //Iframe One Page
    'sms.notify.presentation.buttonInitValidation': 'Iniciar validação',
    'sms.notify.validationFrictionless.checkFinished': 'Validação concluída',
    'sms.notify.validationFrictionless.checking': 'Não feche esta tela. Estamos validando os dados do cartão.',
    'sms.newFooter.termUse': 'Ao continuar, você aceita a <policyButton /> da Unico',
    'sms.newFooter.termPrivacyPolicy': 'Política de Privacidade',

    //PayOne
    'one.boxQrCode.description': 'Aponte a câmera para o QR Code e continue no seu celular.',
    'one.creditCard.ownerCard': 'Titular do cartão',
    'one.creditCard.card': 'Cartão',
    'one.creditCard.cpf': 'CPF',
    'one.creditCard.cardFlags.alt': 'Bandeira do cartão',
    'one.summary.company': 'Pagamento para:',
    'one.summary.value': 'Valor total:',
    'one.button.otherOptions': 'Outras opções',
    'one.modal.otherOptions.title': 'Outras opções',
    'one.modal.otherOptions.subtitle': 'Escolha outra opção a seguir:',
    'one.notify.presentation.hours': 'h',
    'one.notify.presentation.minutes': 'minutos',
    'one.notify.presentation.seconds': 'segundos',
    'one.notify.presentation.expiration': 'Essa validação expira em:',

    //passkey
    'sms.passkey.login.orLine': 'ou',
    'sms.passkey.login.error': 'Houve um problema ao tentar autenticar o seu dispositivo',
    'sms.passkey.login.success': 'Autenticação realizada com sucesso',
    'sms.passkey.register.success': 'Registro realizado com sucesso',
    'sms.passkey.register.error': 'Houve um problema ao tentar registrar o seu dispositivo. Tente novamente mais tarde.',
    'sms.passkey.register.title': 'Facilite os próximos pagamentos',
    'sms.passkey.register.subtitle': 'Use a validação do seu dispositivo para autorizar seus próximos pagamentos mais rápido.',
    'sms.passkey.register.titleContinue': 'Antes de continuar<br />Facilite os próximos pagamentos',
    'sms.passkey.register.subtitleContinue': 'Use a validação do seu dispositivo para autorizar seus próximos pagamentos mais rápido ou clique em "Continuar sem cadastrar".',
    'sms.passkey.register.wallet.titleContinue': 'Facilite as próximas validações',
    'sms.passkey.register.wallet.subtitleContinue': 'Use a biometria do seu dispositivo para validar sua identidade',
    'sms.passkey.register.waiting': 'Aguarde.<br />Estamos registrando o seu dispositivo.',
    'sms.passkey.register.button.noRegister': 'Não quero usar meu dispositivo',
    'sms.passkey.register.button.continueWithoutRegister': 'Continuar sem cadastrar',
    'sms.passkey.register.countdownRedirect': 'Continuando em {{countdown}}s',
    'sms.passkey.register.helpPage.title': 'Como Passkey funciona',
    'sms.passkey.register.helpPage.rocket.title': 'Acelere as suas autorizações',
    'sms.passkey.register.helpPage.rocket.description': 'Não precisará tirar uma fotografia biométrica na sua próxima compra.',
    'sms.passkey.register.helpPage.wallet.rocket.title': 'Acelere suas validações',
    'sms.passkey.register.helpPage.wallet.rocket.description': 'Em sua próxima validação de identidade, você não precisará ter que tirar uma foto biométrica',
    'sms.passkey.register.helpPage.padLock.title': 'Mais privacidade',
    'sms.passkey.register.helpPage.padLock.description': 'Criamos um acesso rápido à sua identidade que só você pode acessar.',
    'sms.passkey.register.helpPage.shield.title': 'Segurança avançada',
    'sms.passkey.register.helpPage.shield.description': 'Os seus dados são encriptados, garantindo uma maior segurança para a sua identidade.',
    'sms.modal.successPhoto.description': 'Selfie enviada com sucesso',
  }
}
